import { Divider, Flex, Heading, Text } from '@backend/lib-design-system';
import {
  DollarCircleOutlinedIcon,
  LocationOutlinedIcon,
  TimeCircleOutlinedIcon,
  WorkOutlinedIcon,
} from '@backend/lib-design-system/icons';
import type { FC } from 'react';
import { styled } from 'styled-components';

import type { JobOffer } from '~/business/JobOffer/types';
import { MissionApplyButton } from '~/components/Mission/ApplyButton';
import { useTranslation } from '~/hooks';

const InfosWrapper = styled.div`
  width: 100%;
`;

const InfosTitle = styled(Heading)`
  /* @TODO change when 2.5 rem is available as spacing */
  /* margin-bottom: ${({ theme }) => theme.space.layout.x.xl}; */
  margin-bottom: 2.5rem;
`;

const ApplyButtonWrapper = styled.div`
  margin: ${({ theme }) => theme.space.layout.x.xl} 0;
`;

const InfosDivider = styled(Divider)`
  margin: ${({ theme }) => theme.space.layout.x.s} 0;
`;

const InfosFlexRow = styled(Flex.Row)`
  flex-wrap: nowrap;
  margin: ${({ theme }) => theme.space.layout.x.m} 0;
`;

type InfosProps = JobOffer & {
  onMissionApplyClick?: () => void;
};

export const MissionInfo: FC<InfosProps> = ({
  location,
  salaryFormattedCurrency,
  salaryFormattedUnit,
  typeLabel,
  weeklyHours,
  onMissionApplyClick,
}) => {
  const t = useTranslation();
  return (
    <InfosWrapper>
      <InfosTitle variant="heading-4" forwardedAs="h2" className="infosTitle">
        {t('missions.informations')}
      </InfosTitle>
      <Text variant="body-light" as="div">
        {salaryFormattedCurrency && salaryFormattedUnit && (
          <>
            <InfosFlexRow justifyContent="flex-start" space="m">
              <DollarCircleOutlinedIcon size="m" />
              <span>
                {salaryFormattedCurrency} {salaryFormattedUnit}
              </span>
            </InfosFlexRow>
            <InfosDivider />
          </>
        )}
        {weeklyHours && (
          <>
            <InfosFlexRow justifyContent="flex-start" space="m">
              <TimeCircleOutlinedIcon size="m" />
              <span>{t('missions.weekly_hours.default', { hours: weeklyHours })}</span>
            </InfosFlexRow>
            <InfosDivider />
          </>
        )}
        <InfosFlexRow justifyContent="flex-start" space="m" alignItems="flex-start">
          <LocationOutlinedIcon style={{ marginTop: '0.2rem' }} size="m" />
          <div>
            <div>{location.city}</div>
            <div>{location.postalCode}</div>
          </div>
        </InfosFlexRow>
        <InfosDivider />
        <InfosFlexRow justifyContent="flex-start" space="m">
          <WorkOutlinedIcon size="m" />
          <span>{typeLabel}</span>
        </InfosFlexRow>
      </Text>
      <ApplyButtonWrapper>
        <MissionApplyButton onClick={onMissionApplyClick} />
      </ApplyButtonWrapper>
    </InfosWrapper>
  );
};
